var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTubeRotor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 33,
    viewBox: "0 0 22 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.14258 11.5961V28.0025C3.14258 28.0025 3.55074 29.22 4.88898 28.888V31.1016L7.78849 32.4298L9.0152 30.7695C9.0152 30.7695 10.5765 31.655 12.2493 30.9909V32.8725C12.2493 32.8725 12.5838 32.8725 12.6953 32.9832C12.8069 33.0939 15.5949 32.6511 15.9294 31.8764L16.0409 29.552C16.0409 29.552 18.6059 31.1016 19.1635 28.3345L19.6096 11.2896L3.14258 11.5961Z",
    fill: "#F15E5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4129 14.175C17.1716 14.175 21.84 11.3232 21.84 7.80529C21.84 4.28738 17.1716 1.43555 11.4129 1.43555C5.6542 1.43555 0.98584 4.28738 0.98584 7.80529C0.98584 11.3232 5.6542 14.175 11.4129 14.175Z",
    fill: "#F78181"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4129 12.7395C17.1716 12.7395 21.84 9.88764 21.84 6.36974C21.84 2.85183 17.1716 0 11.4129 0C5.6542 0 0.98584 2.85183 0.98584 6.36974C0.98584 9.88764 5.6542 12.7395 11.4129 12.7395Z",
    fill: "#F15E5A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3586 6.03219C16.3586 7.65257 14.0903 8.96526 11.2934 8.96526C8.49647 8.96526 6.24155 7.66143 6.22705 6.0488V6.03219C6.22705 4.41291 8.49535 3.09912 11.2934 3.09912C14.0914 3.09912 16.3586 4.41513 16.3586 6.03219Z",
    fill: "#8E1F1D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.31299 11.7378V27.3439C3.31299 27.3439 3.66205 28.5614 4.88877 28.6721L5.00029 19.1535L3.99661 14.7262L3.31299 11.7378Z",
    fill: "#ED3431"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.12275 14.9419L8.01123 31.6549L9.01492 30.4374L8.12275 14.9419Z",
    fill: "#ED3431"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5001 14.6099L18.2771 28.6664C18.2771 28.6664 17.9425 30.6587 16.1582 28.9985L16.2697 24.3499L18.5001 14.6099Z",
    fill: "#ED3431"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5838 15.938L12.1378 30.88L11.2456 15.938H12.5838Z",
    fill: "#ED3431"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5752 5.28829C6.78708 3.76752 9.05316 2.71715 11.714 2.92966C14.4228 3.14548 16.516 4.58988 16.4045 6.15492V6.17042C16.3633 6.6873 16.0867 7.15217 15.6373 7.53623C15.6373 7.50414 15.6451 7.47204 15.6484 7.43883V7.42334C15.7599 5.85719 13.6667 4.41501 10.9579 4.19918C9.13234 4.05308 7.493 4.50134 6.5752 5.28829Z",
    fill: "#BE2A27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTubeRotor);
export default __webpack_public_path__ + "static/media/TubeRotor.e50fce23d365a219f7d5a611cf72cf19.svg";
export { ForwardRef as ReactComponent };